import SectionHeading from "@/components/base/SectionHeading";
import { voices } from "@/mocks/site";

export default function VoicesSection() {
  return (
    <section className="border-y border-background-200/70 bg-background-100/50">
      <div className="mx-auto max-w-content px-4 py-16 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="READERS"
          title="读者怎么评价这套写法"
          description="我们不追热点，只把顺序排清楚。以下是长期读者与业界朋友对内容的真实反馈。"
          align="center"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3">
          {voices.map((item, index) => (
            <figure
              key={item.name}
              className="flex h-full flex-col rounded-lg border border-background-200/70 bg-background-100 p-6"
            >
              <i
                className={`mb-4 text-3xl ${
                  index === 1 ? "ri-double-quotes-r text-accent-500" : "ri-double-quotes-l text-primary-500"
                }`}
              />
              <blockquote className="flex-1 text-sm leading-relaxed text-foreground-700">
                {item.text}
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3 border-t border-background-200/70 pt-5">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-950 font-heading text-sm font-bold text-accent-400">
                  {item.name.slice(0, 1)}
                </span>
                <span>
                  <span className="block text-sm font-medium text-foreground-900">{item.name}</span>
                  <span className="block text-xs text-foreground-500">{item.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}